import { render, staticRenderFns } from "./DescriptionList.vue?vue&type=template&id=7385edde&scoped=true"
import script from "./DescriptionList.vue?vue&type=script&lang=js"
export * from "./DescriptionList.vue?vue&type=script&lang=js"
import style0 from "./DescriptionList.vue?vue&type=style&index=0&id=7385edde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7385edde",
  null
  
)

export default component.exports